export class ContactUs {
  Name: string = '';
  CompanyName: string = '';
  Email: string = '';
  PhoneNumber: string = '';
  Comments: string = '';
}
